var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('list-page-shell',{attrs:{"title":"公示中"}},[_c('order-workbench',{attrs:{"show-title":false,"show-announcement-columns":true,"hide-primary-actions":true,"auto-column-width":true,"extra-query-params":{ publicity_list: 1 }}})],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6967e670","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/views/PublicityList.vue
// module id = rdgf
// module chunks = 0